import _WizardStepsCtrl from './_WizardStepsCtrl';
import templateStr from 'text!./templates/wizard-sidebar-ribbon.html';

export default function () {
    return {
        restrict: 'A',
        replace: true,
        template: templateStr,
        controller: _WizardStepsCtrl,
        scope: {
            title: '@'
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/wizard/WizardSidebarRibbonDirective.js
// module id = 2064
// module chunks = 0